export class PoliceManifestationGender {
    get id() {
        return this.policeManifestationGenderState.id;
    }
    get ndiligencia() {
        return this.policeManifestationGenderState.ndiligencia;
    }
    get userId() {
        return this.policeManifestationGenderState.userId;
    }
    get ocularInspection() {
        return this.policeManifestationGenderState.ocularInspection;
    }
    get eyeInspectionResult() {
        return this.policeManifestationGenderState.eyeInspectionResult;
    }
    get samplesInvolved() {
        return this.policeManifestationGenderState.samplesInvolved;
    }
    get sampleTypes() {
        return this.policeManifestationGenderState.sampleTypes;
    }
    get weaponsIntervene() {
        return this.policeManifestationGenderState.weaponsIntervene;
    }
    get typesWeapons() {
        return this.policeManifestationGenderState.typesWeapons;
    }
    get armsWithdrawalProcedure() {
        return this.policeManifestationGenderState.armsWithdrawalProcedure;
    }
    get interestingData() {
        return this.policeManifestationGenderState.interestingData;
    }
    get transferHealthCenter() {
        return this.policeManifestationGenderState.transferHealthCenter;
    }
    get accompanyAddressEffects() {
        return this.policeManifestationGenderState.accompanyAddressEffects;
    }
    get accompanyFamilyHome() {
        return this.policeManifestationGenderState.accompanyFamilyHome;
    }
    get transferReceptionCenter() {
        return this.policeManifestationGenderState.transferReceptionCenter;
    }
    get observations() {
        return this.policeManifestationGenderState.observations;
    }
    get referralDate() {
        return this.policeManifestationGenderState.referralDate;
    }
    get numFoliosRemission() {
        return this.policeManifestationGenderState.numFoliosRemission;
    }
    get numReferralMinutes() {
        return this.policeManifestationGenderState.numReferralMinutes;
    }
    get independentMinutes() {
        return this.policeManifestationGenderState.independentMinutes;
    }
    get numCitations() {
        return this.policeManifestationGenderState.numCitations;
    }
    get citations() {
        return this.policeManifestationGenderState.citations;
    }
    get bodyTransfer() {
        return this.policeManifestationGenderState.bodyTransfer;
    }
    set id(id) {
        this.policeManifestationGenderState.id = id;
    }
    set ndiligencia(ndiligencia) {
        this.policeManifestationGenderState.ndiligencia = ndiligencia;
    }
    set userId(userId) {
        this.policeManifestationGenderState.userId = userId;
    }
    set ocularInspection(ocularInspection) {
        this.policeManifestationGenderState.ocularInspection = ocularInspection;
    }
    set eyeInspectionResult(eyeInspectionResult) {
        this.policeManifestationGenderState.eyeInspectionResult = eyeInspectionResult;
    }
    set samplesInvolved(samplesInvolved) {
        this.policeManifestationGenderState.samplesInvolved = samplesInvolved;
    }
    set sampleTypes(sampleTypes) {
        this.policeManifestationGenderState.sampleTypes = sampleTypes;
    }
    set weaponsIntervene(weaponsIntervene) {
        this.policeManifestationGenderState.weaponsIntervene = weaponsIntervene;
    }
    set typesWeapons(typesWeapons) {
        this.policeManifestationGenderState.typesWeapons = typesWeapons;
    }
    set armsWithdrawalProcedure(armsWithdrawalProcedure) {
        this.policeManifestationGenderState.armsWithdrawalProcedure = armsWithdrawalProcedure;
    }
    set interestingData(interestingData) {
        this.policeManifestationGenderState.interestingData = interestingData;
    }
    set transferHealthCenter(transferHealthCenter) {
        this.policeManifestationGenderState.transferHealthCenter = transferHealthCenter;
    }
    set accompanyAddressEffects(accompanyAddressEffects) {
        this.policeManifestationGenderState.accompanyAddressEffects = accompanyAddressEffects;
    }
    set accompanyFamilyHome(accompanyFamilyHome) {
        this.policeManifestationGenderState.accompanyFamilyHome = accompanyFamilyHome;
    }
    set transferReceptionCenter(transferReceptionCenter) {
        this.policeManifestationGenderState.transferReceptionCenter = transferReceptionCenter;
    }
    set observations(observations) {
        this.policeManifestationGenderState.observations = observations;
    }
    set referralDate(referralDate) {
        this.policeManifestationGenderState.referralDate = referralDate;
    }
    set numFoliosRemission(numFoliosRemission) {
        this.policeManifestationGenderState.numFoliosRemission = numFoliosRemission;
    }
    set numReferralMinutes(numReferralMinutes) {
        this.policeManifestationGenderState.numReferralMinutes = numReferralMinutes;
    }
    set independentMinutes(independentMinutes) {
        this.policeManifestationGenderState.independentMinutes = independentMinutes;
    }
    set numCitations(numCitations) {
        this.policeManifestationGenderState.numCitations = numCitations;
    }
    set citations(citations) {
        this.policeManifestationGenderState.citations = citations;
    }
    set bodyTransfer(bodyTransfer) {
        this.policeManifestationGenderState.bodyTransfer = bodyTransfer;
    }
    constructor(policeManifestationGenderState) {
        this.policeManifestationGenderState = policeManifestationGenderState;
    }
    getState() {
        return this.policeManifestationGenderState;
    }
}
